import { useT, type MessageKey } from '../../i18n/i18n';
import { CheckRow, InlineMessage } from '../../ui/components';

// The web version's automatic-renewal block (Owner decision list 2026-10-19 item 39; NY GBL §527-a): the terms
// sit right above the tick the subscription buttons need, and the reminder to tick sits right under it (Owner
// rule 9). The server keeps the tick before the payment page opens (src/state/billingStore.ts runPurchase).
export const WEB_RENEWAL_TERMS: readonly MessageKey[] = Object.freeze(['billing.terms1.web', 'billing.terms5.web', 'billing.terms6.web'] as MessageKey[]);

export function AutoRenewConsent(props: { checked: boolean; missing: boolean; onChange: (value: boolean) => void; testId?: string }) {
  const { t } = useT();
  const id = props.testId ?? 'auto-renew';
  return (
    <div className="billing-consent" data-testid={id}>
      <ul className="billing-terms" data-testid={`${id}-terms`}>
        {WEB_RENEWAL_TERMS.map((key) => (
          <li key={key}>{t(key)}</li>
        ))}
      </ul>
      <CheckRow label={t('billing.autoRenewConsent')} checked={props.checked} onChange={props.onChange} testId={`${id}-tick`} />
      {props.missing ? <InlineMessage kind="err" text={t('billing.autoRenewNeedConsent')} /> : null}
    </div>
  );
}
